import type { CSSProperties } from 'react';

const RADIUS = 26;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

interface ProgressDialProps {
  /** Pasos completados. */
  value: number;
  /** Total de pasos. */
  total: number;
  /** Texto accesible (`aria-valuetext`) — describe el progreso en palabras. */
  label: string;
  /** Diámetro en px del anillo. Default 64. */
  size?: number;
}

/** Anillo de progreso reutilizable, sin conocimiento de dominio. */
export function ProgressDial({ value, total, label, size = 64 }: Readonly<ProgressDialProps>) {
  const safeTotal = total > 0 ? total : 1;
  const ratio = Math.min(1, Math.max(0, value / safeTotal));
  const offset = CIRCUMFERENCE * (1 - ratio);
  const isComplete = total > 0 && value >= total;

  return (
    <div
      className={`progress-dial ${isComplete ? 'progress-dial--complete' : ''}`}
      style={{ '--progress-dial-size': `${size}px` } as CSSProperties}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={total}
      aria-valuenow={value}
      aria-valuetext={label}
    >
      <svg viewBox="0 0 64 64" width={size} height={size}>
        <circle className="progress-dial-track" cx="32" cy="32" r={RADIUS} />
        <circle
          className="progress-dial-fill"
          cx="32"
          cy="32"
          r={RADIUS}
          strokeDasharray={CIRCUMFERENCE}
          strokeDashoffset={offset}
        />
      </svg>
      <span className="progress-dial-value">{isComplete ? '✓' : `${value}/${total}`}</span>
    </div>
  );
}

export default ProgressDial;
